/**
 * API origin resolution (ADR 0019). In dev `VITE_API_BASE_URL` is unset, so requests are
 * relative (`/api/v2/...`) and Vite proxies them to a local `wrangler dev` (same-origin — no
 * CORS). In production it is the Worker origin (e.g. `https://api.<brand>`) and requests go
 * cross-origin (the Worker's CORS allows `PUBLIC_WEB_HOST`).
 */
const apiRoot = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/** REST base, e.g. `/api/v2` (dev) or `https://api.<brand>/api/v2` (prod). */
export const API_BASE = `${apiRoot}/api/v2`;

/** Build an absolute WebSocket URL for a realtime path (`WebSocket` needs an absolute URL). */
export function wsUrl(path: string): string {
  const root = apiRoot || window.location.origin;
  return `${root.replace(/^http/, 'ws')}/api/v2${path}`;
}

/**
 * Product brand shown in the shell/login (ADR 0015 — env-driven, never hardcoded; the Bia
 * brand is not final). Set `VITE_BRAND_NAME` per deployment; defaults to `Bia`.
 */
export const BRAND = import.meta.env.VITE_BRAND_NAME || 'Bia';
